module.exports = __webpack_public_path__ + "static/media/summerBg.4cd627f6.jpeg";